import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { CRUMB_LABEL_KEY, NAME } from '../constants';
import { apiProvider } from '../api';

const edit = {
	ZaznamId: null as number | null,
	Text: null as string | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	VyrazenDat: null as Date | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
